import OverflowTooltip from '@components/OverflowTooltip/OverflowTooltip';
import { CrossIcon } from '@icon/index';
import { FC } from 'react';

interface ImagePreviewProps {
    src: string;
    name: string;
    onCancel?: () => void;
}

const ImagePreview: FC<ImagePreviewProps> = (props) => {
    const { src, name, onCancel } = props;

    return (
        <div className="border border-grayscale-100 rounded-[10px] p-4">
            <div className="flex items-center gap-3">
                <div>
                    <img className="w-8" src={src} />
                </div>

                <div className="flex-1 overflow-hidden mr-3">
                    <OverflowTooltip className="text-sm font-semibold overflow-hidden whitespace-nowrap text-ellipsis">
                        {name}
                    </OverflowTooltip>
                </div>
                {onCancel && (
                    <button type="button" className="ml-auto" onClick={onCancel}>
                        <CrossIcon className="text-danger-500" width="10" height="10" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default ImagePreview;
